import React from 'react';

const SyncPermissionsButton = ({ onSync, loading = false }) => (
  <button
    className={`px-3 py-1 rounded text-sm transition-colors ${
      loading 
        ? 'bg-gray-300 text-gray-500 cursor-not-allowed' 
        : 'bg-blue-100 text-blue-700 hover:bg-blue-200'
    }`}
    onClick={onSync}
    disabled={loading}
    title="Synchroniser les permissions avec les routes de l'application"
  >
    {loading ? (
      <span className="flex items-center">
        <svg className="animate-spin -ml-1 mr-2 h-4 w-4 text-gray-500" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
          <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
          <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
        </svg>
        Synchronisation...
      </span>
    ) : (
      'Synchroniser les permissions'
    )}
  </button>
);

export default SyncPermissionsButton;
